<template>
  <div>
    <div>
      <b-table
        responsive
        :key="dataList.keyTableRender"
        :items="rows"
        :fields="schema"
        borderless="borderless"
        show-empty
        striped
      >
        <template #empty="">
          <span class="text-center w-full push-left">{{ 'No se encontraron datos para mostrar' }}</span>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dataList'],
  data() {
    return {
      rows: [],
      schema: []
    }
  },
  mounted() {
    this.setInitialData()
  },
  computed: {
    formattedLimitServices() {
      if (
        this.dataList &&
        this.dataList.rows &&
        this.dataList.rows[0] &&
        Array.isArray(this.dataList.rows[0].limit_services)
      ) {
        const visibleServices = this.dataList.rows[0].limit_services
          .filter(service => service.show_in_catalog)
          .map(service => service.name) // Obtener solo los nombres

        return visibleServices.length > 0 ? visibleServices.join(', ') : '--'
      }
      return '--'
    }
  },
  watch: {
    'dataList.rows'() {
      this.setInitialData()
    },
    'dataList.keyTableRender'() {
      this.setInitialData()
    }
  },
  methods: {
    setInitialData() {
      this.setSchema()
      this.setRows()
    },
    setSchema() {
      this.schema = [
        { key: 'carrier_name', label: 'Operador'},
        { key: 'limit_services_names', label: 'Servicios'},
        { key: 'min_val', label: 'min. COD', class:'text-left'},
        { key: 'max_val', label: 'Máx. COD', class:'text-left'},
        { key: 'percentage_cash', label: 'COD- Efectivo', class:'text-left'},
        { key: 'cash', label: 'min. pago-Efectivo', class:'text-left' },
        { key: 'percentage_instant_payment', label: 'COD- Tarjeta Debito / Prepago / PSE', class:'text-left'},
        { key: 'instant_payment', label: 'min. pago-Tarjeta Debito / Prepago / PSE', class:'text-left' },
        { key: 'percentage_credit_card', label: 'COD- Tarjeta Crédito', class:'text-left' },
        { key: 'credit_card', label: 'min. pago-Tarjeta Crédito', class:'text-left' },
        { key: 'delivery_creation_info', label: 'Información para creación de envío', class:'text-left' },
        { key: 'collection_cycle', label: 'Ciclo de recaudo/conciliación', class:'text-left' },
        { key: 'deposit_in_account', label: 'Abono en cuenta', class:'text-left' },
        { key: 'coverage_population', label: 'Cobertura / Poblaciones', class:'text-left' },
        { key: 'observations', label: 'Observaciones', class:'text-left' }
      ]
    },
    setRows() {
      this.rows = this.dataList.rows.map((item) => {
        return {
          ...item,
          countryName: this.dataList.country,
          limit_services_names: this.formattedLimitServices
        }
      })
    }
  }
}
</script>
